// src/components/ui/LoadingSpinner.jsx
import React from 'react';

const LoadingSpinner = ({ size = 'md', color = 'primary' }) => {
  // Définir les tailles
  const sizeMap = {
    sm: 'w-6 h-6 border-2',
    md: 'w-10 h-10 border-3',
    lg: 'w-14 h-14 border-4'
  };
  
  // Définir les couleurs
  const colorMap = {
    primary: 'border-ff4966',
    gray: 'border-gray-300',
    white: 'border-white'
  };
  
  const sizeClass = sizeMap[size] || sizeMap.md;
  const colorClass = colorMap[color] || colorMap.primary;
  
  return (
    <div className={`${sizeClass} ${colorClass} rounded-full border-t-transparent animate-spin`}></div>
  );
};

export default LoadingSpinner;